__turbopack_context__.v({
  "projectAvatarWrapper": "ProjectListItem-module__ELUBNa__projectAvatarWrapper",
  "projectStatusLabel": "ProjectListItem-module__ELUBNa__projectStatusLabel",
  "restrictedBadge": "ProjectListItem-module__ELUBNa__restrictedBadge",
});
